(function() {
    'use strict';

    angular.module('format')
        .controller('FormatUpdateController', FormatUpdateController);

    FormatUpdateController.$inject = ['$state', 'formatSrvc', 'formatDataSrvc', 'notificationSrvc', 'formatMessagesConst', 'formatGroupDataSrvc', 'errorNotificationSrvc'];

    function FormatUpdateController($state, formatSrvc, formatDataSrvc, notificationSrvc, formatMessagesConst, formatGroupDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            sheet_format: [],
            size_x: [],
            size_y: [],
            format_group: [],
            nonFieldErrors: []
        };

        self.sizeFields = [{
            prop: 'size_x',
            type: 'number',
            title: 'Rozmiar x',
            isRequired: true,
            isDisabled: false,
            minValue: 0,
            onChange: cleanErrors
        }, {
            prop: 'size_y',
            type: 'number',
            title: 'Rozmiar y',
            isRequired: true,
            isDisabled: false,
            minValue: 0,
            onChange: cleanErrors
        }];
        self.formatData = {};

        self.groupsList = [];
        self.groupName = null;

        self.updateFormat = updateFormat;
        self.cleanErrors = cleanErrors;

        self.redirectTo = redirectTo;

        activate();

        function activate() {
            getFormat();
            getGroups();

            if ($state.params.groupPk) {
                getGroupName($state.params.groupPk);
            }
        }

        function getGroups() {
            return formatGroupDataSrvc.forFormatsList()
                .$promise.then(function(response) {
                    self.groupsList = response;
                    return response;
                });
        }

        function getGroupName(pk) {
            return formatGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name;
                delete self.formatData.date_modified;
                delete self.formatData.date_added;
                return response;
            });
        }

        function getFormat() {
            return formatDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.formatData = response;
                delete self.formatData.date_modified;
                delete self.formatData.date_added;
                return response;
            });
        }

        function updateFormat() {
            formatDataSrvc.update({
                pk: self.formatData.pk
            }, self.formatData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", formatMessagesConst.update);
                    self.redirectTo();
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function redirectTo() {
            if ($state.params.groupPk) {
                $state.go('layout.formatGroup.detail', { pk: $state.params.groupPk });
            } else {
                $state.go('layout.format.list');
            }
        }
    }
})();
